import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import UserRoleSelect from "../projectManager/UserRoleSelect";
import { createUser } from "../../../redux/ducks/user";
import TextInput from "../../dumb/TextInput";
import PassInput from "../../dumb/PassInput";
import CheckInput from "../../dumb/CheckInput";

const CreateUser = props => {
    const [show, hide, renderModal] = useModal();
    const [d_createUser, status, error, event] = useStatusThunk(createUser);

    const [name, setName] = useState();
    const [first, setFirst] = useState();
    const [last, setLast] = useState();
    const [email, setEmail] = useState();
    const [role, setRole] = useState();
    const [password, setPassword] = useState();
    const [sendEmail, setShouldEmail] = useState(true);

    event.onSuccess = () => {
        hide();
        setName(null);
        setEmail(null);
        setRole(null);
        setPassword(null);
        setEmail(null);
    }

    return (
        <React.Fragment>
            <button className={"button button--primary " + props.className} onClick={show}>Create User</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Username</div>
                        <TextInput set={setName} v={name} />
                    </div>

                    <div className="group">
                        <div className="label">Password</div>
                        <PassInput set={setPassword} v={password} />
                    </div>

                    <div className="double-inputs">
                        <div className="group">
                            <div className="label">First</div>
                            <TextInput set={setFirst} v={first} />
                        </div>

                        <div className="group">
                            <div className="label">Last</div>
                            <TextInput set={setLast} v={last} />
                        </div>
                    </div>

                    <div className="group">
                        <div className="label">Email</div>
                        <TextInput set={setEmail} v={email} />
                    </div>

                    <div className="group">
                        <div className="label">Role</div>
                        <UserRoleSelect onChange={e => setRole(e.target.value)} />
                    </div>

                    <div className="group">
                        <div className="label">Send Email</div>
                        <CheckInput set={setShouldEmail} v={sendEmail} />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--primary" onClick={() => { d_createUser({ username: name, role, password, email, sendEmail, firstname: first, lastname: last }) }}>Create User</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default CreateUser;